<template>
	<v-dialog v-model="show" width="360">
		<v-card color="white" title="Error" class="pa-2">
			<v-card-text class="text-secondary" v-if="errorMessage">
				<p v-if="eCode" class="mb-2"><strong>Error code:</strong> {{ eCode }}</p>
				<p>{{ sanitize(errorMessage) }}</p>
			</v-card-text>
			<v-card-text class="text-secondary" v-else>
				<p v-if="eCode" class="mb-2"><strong>Error code:</strong> {{ eCode }}</p>
				<p>
					An error occurred, please refresh and try again. If the issue continues,
					<router-link @click.stop="handleContactClick" :to="contactPath">contact us.</router-link>
				</p>
			</v-card-text>

			<v-card-actions class="justify-end">
				<v-btn text="Close" @click.stop="show = false" class="link"></v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { sanitize } from '../utils/utils'
export default {
	props: {
		errorMessage: String,
		errorCode: String,
		value: Boolean
	},
	data() {
		return {
			isContactClick: false
		}
	},
	computed: {
		show: {
			get() {
				return this.value || this.$showError.value
			},
			set(value) {
				this.$Error(value)
				// Pass additional context about how the dialog was closed
				this.$emit('update:modelValue', value, { viaContact: this.isContactClick })
				// Reset flag after emitting
				if (!value) {
					this.isContactClick = false
				}
			}
		},
		eCode() {
			return this.$errCode.value ? this.$errCode.value : this.errorCode ? this.errorCode : false
		},
		contactPath() {
			if (
				this.$route.meta.requiresAuth &&
				this.$route.name != 'SelectPlan' &&
				this.$route.name !== 'AuthSuccess'
			) {
				return '/contact-us'
			} else {
				return '/contact'
			}
		}
	},
	methods: {
		sanitize: sanitize,
		handleContactClick() {
			this.isContactClick = true
			this.show = false
		}
	}
}
</script>
